/* src/app/components/core/layout/footer/font-selector/font-selector.component.css */
.font-selector {
  font-weight: 300;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  height: 32px;
  margin: 0;
  padding: 0;
}
.font-selector label {
  color: #FFFFFF;
}
.font-selector select {
  color: #FFFFFF;
  background-color: transparent;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 4px;
  padding: 4px 8px;
  height: 32px;
  line-height: 1;
  margin: 0;
}
.font-selector select:hover {
  border-color: rgba(255, 255, 255, 0.6);
}
.font-selector select option {
  background-color: #004C4A;
  color: #FFFFFF;
}
@media (max-width: 600px) {
  .font-selector {
    height: 24px;
    align-items: center;
    line-height: 1;
    margin: 0;
    padding: 0;
  }
  .font-selector select {
    height: 24px;
    line-height: 24px;
    padding: 0 4px;
    font-size: 0.65rem;
    vertical-align: middle;
    margin: 0;
  }
}
/*# sourceMappingURL=font-selector.component-RPKCQK7Y.css.map */
